<template>
  <button @click="clickBtn" class="button" style="width:60px">복사하기</button>
</template>

<script>
export default {
  name: "ClipboardBtn",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    clickBtn() {
      this.$copyText(this.text).then(()=>{
        this.toast('클립보드에 복사되었습니다.');
      }, ()=> {
        this.toast('클립보드로 복사하는데 실패하였습니다.');
      });
    }
  }
}
</script>

<style scoped>

</style>
